// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const WarrantyExpiration = t.struct({
    city: t.maybe(t.String),
    contractPurchaseDate: t.maybe(t.Number),
    country: t.maybe(t.String),
    coverageType: t.maybe(t.String),
    customerName: t.maybe(t.String),
    customerNumber: t.maybe(t.String),
    dealer: t.maybe(t.String),
    dealerCity: t.maybe(t.String),
    dealerName: t.maybe(t.String),
    description: t.maybe(t.String),
    email: t.maybe(t.String),
    expirationDate: t.maybe(t.Number),
    model: t.maybe(t.String),
    phone: t.maybe(t.String),
    pin: t.maybe(t.String),
    postalCode: t.maybe(t.String),
    region: t.maybe(t.String),
    startDate: t.maybe(t.Number),
    street1: t.maybe(t.String),
    street2: t.maybe(t.String),
    warrantyHoursLimit: t.maybe(t.String),
    warrantyType: t.maybe(t.String)
}, {
    name: 'WarrantyExpiration',
    strict: true
});

export const getDefaultState = () => new WarrantyExpiration({});

export default WarrantyExpiration;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/warranty-expiration.js